module.exports = __webpack_public_path__ + "static/media/logonav2.d1bfcb8f.png";